export default {
    'create-user': 'Add user',
    'edit-user': 'Edit user',
    active: 'Active',
    unactive: 'Deactivated',
    allowed: 'Allowed',
    'not-allowed': 'Not allowed',
    username: 'Username',
    password: 'Password',
    'have-permission-to-create-a-file': 'Has creation file permission',
    save: 'Save',
    cancel: 'Cancel',
    'time-zone': "timezone",
    "default-time-zone": "Default time zone",
    'delete-user': 'Delete user',
    'are-you-sure-you-want-to-delete-the-user-$': 'Do you want to delete this user "{username}"?',
    'change-account-state': 'Change account status',
    'are-you-sure-you-want-to': 'Do you want to',
    'your-current-timezone': 'Your current time zone is',
    'click-for-choose': 'Click to set it',
    'deactivate': 'deactivate',
    'activate': 'activate',
    'account': '{username}\'s account?',
    
    'files-which': 'Files which',
    'has-access-to-it': 'has permission to access',
    "edit-time-zone": "Change time zone",
    temp: {
        'financial-file': 'Financial file',
        permission: 'Permission',
    },

    ok: 'OK',
    confirm: 'Confirm',

    'security-alert': 'Security alert',
    'changing-your-password-required-logout-then-you-can-login': 'You will be signed out and you have to sign in with the new password',

    headers: {
        username: 'Username',
        'permission-to-create-a-file': 'Creation File permission',
        'account-state': 'Account status',
        actions: 'Actions',
    },

    permissions: {
        viewer: 'Read-only permission',
        accountant: 'Accountant',
        advancedAccountant: 'Advanced Accountant',
        warehouseKeeper: 'Warehouse Keeper ',
        warehouseManager: 'Warehouse Manager',
        treasurer: 'Treasurer'
    },


    'there-is-a-user-with-the-same-name': 'User name is prereserved',
    
    addPermission: 'Add Permission',
    NoAddedPermission: 'No added permission',

    'cancel-deportation': 'Can Cancel The Deportation',
    
    'select-the-warehouses': 'Warehouses for warehouse keeper'
}